import CreateEditProcesses from './views/CreateEdit.vue'
import ListProcesses from './views/List.vue'

export const ProcessesRoutes = [
  {
    path: '/processes',
    name: 'ListProcesses',
    component: ListProcesses,
    meta: {
      auth: true,
      layout: 'home'
      // permission: 'processes:list'
    }
  },
  {
    path: '/processes',
    name: 'CreateProcesses',
    component: CreateEditProcesses,
    meta: {
      auth: true,
      layout: 'home'
      // permission: 'processes:create'
    }
  },
  {
    path: '/processes/:id',
    name: 'EditProcesses',
    component: CreateEditProcesses,
    meta: {
      auth: true,
      layout: 'home'
      // permission: 'processes:edit'
    }
  }
]
